// Generated by `bazel run i18n`. Do not edit by hand.
import part0 from "./en/email--content--src--blocks--order-summary.json";
import part1 from "./en/email--content--src--blocks.json";
import part2 from "./en/email--ssr--src.json";
import part3 from "./en/email--templates--src.json";
import part4 from "./en/return--core--backend--src--return-shipping.json";
import part5 from "./en/return--core--backend--src.json";
import part6 from "./en/return--shipping--common--src.json";
import part7 from "./en/src--return-timeline.json";
import part8 from "./en/src.json";

export default Object.assign(
  {},
  part0,
  part1,
  part2,
  part3,
  part4,
  part5,
  part6,
  part7,
  part8,
);
